module.exports = __webpack_public_path__ + "static/img/pic4.3ef42ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/qiye/20200624/pic4.png
// module id = pP2L
// module chunks = 1